import type { RelatedResourceRetrieval } from '../../../types/types';

const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === 'object' && value !== null;

/** Invalid optional metadata must never prevent the AI response from loading. */
export const parseRelatedResourceRetrievals = (
	value: unknown,
): RelatedResourceRetrieval[] | undefined => {
	if (!Array.isArray(value)) {
		return undefined;
	}

	const relatedResourceRetrievals: RelatedResourceRetrieval[] = [];
	for (const relatedResourceRetrieval of value) {
		if (
			!isRecord(relatedResourceRetrieval) ||
			typeof relatedResourceRetrieval.context_retrieval_id !== 'string' ||
			!relatedResourceRetrieval.context_retrieval_id.trim() ||
			!Array.isArray(relatedResourceRetrieval.resources)
		) {
			return undefined;
		}

		const resources: RelatedResourceRetrieval['resources'] = [];
		for (const resource of relatedResourceRetrieval.resources) {
			if (
				!isRecord(resource) ||
				typeof resource.url !== 'string' ||
				typeof resource.ari !== 'string' ||
				!resource.ari.startsWith('ari:')
			) {
				return undefined;
			}
			resources.push({ url: resource.url, ari: resource.ari });
		}
		relatedResourceRetrievals.push({
			contextRetrievalId: relatedResourceRetrieval.context_retrieval_id,
			resources,
		});
	}
	return relatedResourceRetrievals;
};
